import axios from 'axios'
import { readPersistedTokens } from './authStorage'

const DEBUG_EMAIL_KEY = 'workbeam_debug_email'

/** Sync debug mode from URL to sessionStorage. Accepts ?isDebugMode=true or ?DEBUG_MODE=true on any page. */
export function syncDebugEmailFromUrl(): void {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const flag = params.get('isDebugMode') ?? params.get('DEBUG_MODE')
  if (flag === 'true') {
    sessionStorage.setItem(DEBUG_EMAIL_KEY, 'true')
  } else if (flag === 'false') {
    sessionStorage.removeItem(DEBUG_EMAIL_KEY)
  }
}

// Sync on module load (handles initial page load with ?isDebugMode=true)
syncDebugEmailFromUrl()

// Create axios instance with default config
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add X-Debug-Email header when debug mode is enabled (for email redirect to DEBUG_MAIL)
    if (sessionStorage.getItem(DEBUG_EMAIL_KEY) === 'true') {
      config.headers['X-Debug-Email'] = 'true'
    }
    const tokens = readPersistedTokens()
    if (tokens?.accessToken) {
      config.headers.Authorization = `Bearer ${tokens.accessToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor — 401 handling is done in useAuth's interceptor (with token refresh)
api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

export default api
